<template>
  <div class="repair_record">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="flexBox">
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
      <div class="header-btn-box">
        <!--<a @click="toModifyPage" v-if="permissionCodes.indexOf('001001001') !== -1">修改</a>-->
        <a
          @click="toManagePage"
          style="
            display: inline-block;
            width: 89px;
            height: 38px;
            line-height: 38px;
            background: #1362ff;
            border-radius: 8px;
            font-size: 14px;
            color: #fff;
          "
        >
          返回</a>
      </div>
    </div>
    <form class="repair_record-form">
      <div class="form-left">
        <div class="form-top-text">
          <span class="darkBlue"></span>
          <span>报修信息</span>
        </div>
        <div class="form-line" style="justify-content: flex-start;">
          <div class="textBox">
            <span class="line-text">报修人姓名：</span>
          </div>
          <div class="space">{{formData.personName||"无"}}</div>
        </div>

        <div class="form-line" style="justify-content: flex-start;">
          <div class="textBox">
            <span class="line-text">报修人房间名：</span>
          </div>
          <div class="space">{{formData.roomInfoNumber||"无"}}</div>
        </div>

        <div class="form-line" style="justify-content: flex-start;">
          <div class="textBox">
            <span class="line-text">报修类别：</span>
          </div>
          <div class="space">{{formData.repairCategoryName||"无"}}</div>
        </div>

        <div class="form-line" style="justify-content: flex-start;">
          <div class="textBox">
            <span class="line-text">具体情况：</span>
          </div>
          <div class="space">{{formData.detail||"无"}}</div>
        </div>

        <div class="form-line" style="justify-content: flex-start;">
          <div class="textBox">
            <span class="line-text">报修时间：</span>
          </div>
         <div class="space">{{formData.repairTime||"无"}}</div>
        </div>

        <div class="form-line" style="justify-content: flex-start;">
          <div class="textBox">
            <span class="line-text">物业处理人：</span>
          </div>
          <div class="space">{{formData.propertyName||"无"}}</div>
        </div>

        <div class="form-line" style="justify-content: flex-start;">
          <div class="textBox">
            <span class="line-text">接单处理人：</span>
          </div>
          <div class="space">{{formData.receiverName||"无"}}</div>
        </div>

        <div class="form-line" style="justify-content: flex-start;">
          <div class="textBox">
            <span class="line-text">处理结果：</span>
          </div>
          <div class="space">{{formData.memo||"无"}}</div>
        </div>
      </div>

      <div class="form-right">
        <div class="form-right-top">
          <div class="form-top-text">
          <span class="darkBlue"></span>
          <span>报修进度</span>
          </div>

        <div class="form-line" style="margin-top:40px" v-if="formData.repairStatusChanges">
        <el-steps :active="+(formData.status)" align-center style="flex: 1" finish-status="success">
          <el-step title="提报时间" :description="formData.repairStatusChanges[0].time"></el-step>
          <el-step title="派单时间" :description="formData.repairStatusChanges[1].time"></el-step>
          <el-step title="接单时间" :description="formData.repairStatusChanges[2].time"></el-step>
          <el-step title="处理结束" :description="formData.repairStatusChanges[3].time"></el-step>
          <el-step title="付款时间" :description="formData.repairStatusChanges[4].time"></el-step>
          <el-step title="评价时间" :description="formData.repairStatusChanges[5].time"></el-step>
        </el-steps>
        </div>

        </div>
        <div class="form-right-bottom">
          <div class="form-top-text">
            <span class="darkBlue"></span>
            <span>报修反馈</span>
          </div>
        <div class="block">
          <span class="demonstration">满意度:</span>
          <el-rate disabled v-model="formData.star" :colors="colors"></el-rate>
        </div>
        <div class="block" style="display: flex;gap: 12px;">
          <span class="demonstration">图片:</span>
          <el-image
            v-if="formData.pic1"
            style="width: 100px; height: 100px"
            :src="formData.pic1"
            :preview-src-list="[formData.pic1]"
            fit="cover"
          ></el-image>
          <span v-else>无</span>
        </div>
        <div class="block">
          <span class="demonstration">评价时间:</span>
          {{this.formData.starTime||'无'}}
        </div>
        <div class="block">
          <span class="demonstration">反馈:</span>
          {{this.formData.result||'无'}}
        </div>        
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { getObjectURL } from "../../../utils/toBase64";
import $ from "jquery";
import { api } from "../../api/RepairManagement";
import { nError, nSuccess } from "../../../utils/notice";
import { errorHandler } from "../../../utils/errorHandler";
import UploadImgList from "../../../components/Input/UploadImgList";

export default {
  components: {
    UploadImgList,
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "repair-record-current",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧报修",
          name: "repair-category-manage"
        },
        {
          value: "报修记录"
        }
      ],
      mainTitle: "报修记录",
      subheading: "",
      personList: [],
      repairCategoryList: [],
      repairTypeCode: [],
      formData: {},
      colors: ["#1362FF", "#1362FF", "#1362FF"]
    };
  },
  created() {
    this.getRepairRecordByCode();
  },
  methods: {
    toManagePage() {
      this.$router.push({
        name: "repair-record"
      });
    },

    getRepairRecordByCode() {
      this.$axios
        .get(`${api.getRepairRecordByCode}/${this.$route.params.id}`, {})
        .then(res => {
          let data = res.data.data;
          for (let i = 0; i < 6; i++) {
            if (!data.repairStatusChanges[i]) {
              data.repairStatusChanges[i] = { time: "" };
            }
          }
          this.formData = data;
          let statusList=[]
          this.formData.repairStatusChanges.map(v=>{
            if(v.status){
              statusList.push(v.status)
            }
          })
          if(statusList.indexOf('4')==-1 && statusList.indexOf('5')!=-1){
            this.formData.repairStatusChanges[4]=this.formData.repairStatusChanges[3]
          }
        })
        .catch(errorHandler("查询失败"));
    },
    cancel() {
      this.toManagePage();
    }
  }
};
</script>

<style scoped>
.flexBox {
  display: flex;
  justify-content: space-between;
}
.header-btn-box {
  margin: 20px 0 10px 0;
  color: #337ab7;
  font-size: 14px;
}
.header-btn-box a {
  margin-right: 40px;
  cursor: pointer;
}
.header-btn-box a:hover {
  color: #00a0e6;
}
form {
  width: 96%;
  margin: 0 auto;
  /*padding-right: 10%;*/
  text-align: left;
}
.form-line {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}
.form-line > div {
  display: flex;
  justify-content: flex-start;
  line-height: 20px;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
  width: 120px;
  /*height: 50px;*/
  /*line-height: 50px;*/
  text-align: right;
}
.line-info {
  width: 280px;
}
.yq_introduce_box {
  width: 330px;
  max-height: 240px;
  overflow-y: auto;
}
.yq_introduce_box > div {
  text-indent: 2em;
}
.line-text {
  color: #333333;
  font-weight: 500;
  /* font-family: PingFang SC; */
}
.darkBlue {
  display: inline-block;
  margin-right: 8px;
  width: 8px;
  height: 26px;
  background: #1362ff;
  opacity: 1;
  border-radius: 6px;
}
.textBox {
  display: inline-block;
  padding: 7px 0;
  width: 122px;
  line-height: 32px;
  text-align: right;
}
.space {
  margin-left: 60px;
  font-weight: 400;
  margin-top: 6px;
  /* font-family: PingFang SC; */
}
</style>

<style lang="less" scoped>
.repair_record {
  .el-carousel__button {
    width: 10px !important;
  }
  .repair_record-form {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    height: 540px;
    .form-top-text {
      display: flex;
      align-items: center;
      font-size: 16px;
      padding: 0 10px;
      line-height: 40px;
      // background: #eeeeee;
    }
    .form-left {
      width: 420px;
      height: 100%;
      margin-right: 30px;
      border-radius: 7px;
      border: 1px solid #eeeeee;
      .form-left-line {
        margin: 10px 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
    }
    .form-right {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      .form-right-top {
        margin-bottom: 30px;
        border-radius: 7px;
        border: 1px solid #eeeeee;
      }
      .form-right-bottom {
        flex: 1;
        border-radius: 7px;
        border: 1px solid #eeeeee;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        .editorBox {
          flex: 1;
          /deep/ .ql-editor {
            display: flex;
            justify-content: flex-start;
            flex-direction: column;
          }
        }
      }
    }
  }
}
/deep/ .el-step__description {
  width: 150px;
}
/deep/ .el-step.is-center .el-step__description {
  margin-top: -100px;
  margin-bottom: 40px;
  padding: 10% 0;
  color: #1362ff;
}
/deep/ .el-step__title.is-success {
  color: #1362ff;
  .el-step__icon.is-text {
    background-color: #1362ff;
  }
}
/deep/ .el-step__head.is-success {
  color: #1362ff;
  font-weight: 700;
  border-color: #1362ff;
}
.block {
  margin: 20px;
}
.el-rate {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/view/RepairManagement/repairRecord/repairRecordCurrent.vue